import React, { PureComponent } from 'react'
import FormGroup from '@material-ui/core/FormGroup'
import { Grid, ListItem, Checkbox } from '@material-ui/core'
import moment from 'moment'
import { EditableDateInput } from '../common/EditableComponents'

export default class TimecardEdit extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      timecard: props.timecard || {},
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.timecard !== this.props.timecard) {
      this.setState({
        timecard: nextProps.timecard,
      })
    }
  }

  onDateChange(key, value) {
    let { timecard } = this.state

    timecard = {
      ...timecard,
      timeCard: {
        ...timecard.timeCard,
        [key]: parseInt(moment(value).format('x'), 10),
      },
    }

    this.setState({
      timecard: timecard,
    })

    this.props.onChange(timecard)
  }

  clockinChange = (e) => {
    let { timecard } = this.state

    timecard = {
      ...timecard,
      timeCard: {
        ...timecard.timeCard,
        clockin: e.target.checked,
      },
    }

    this.setState({
      timecard: timecard,
    })

    this.props.onChange(timecard)
  }

  render() {
    const { timecard } = this.state

    return (
      <Grid container className="paper-page">
        <ListItem>
          <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
            Clock In Time
          </Grid>
          <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
            <EditableDateInput
              className="emp-date-picker"
              valueToRender={
                timecard && timecard.timeCard && timecard.timeCard.clockInTime
                  ? moment(new Date(timecard.timeCard.clockInTime)).format('MM/DD/YYYY h:mm A')
                  : ''
              }
              editMode={true}
              value={
                timecard && timecard.timeCard && timecard.timeCard.clockInTime
                  ? moment(new Date(timecard.timeCard.clockInTime)).format('MM/DD/YYYY h:mm A')
                  : ''
              }
              onChange={(date) => this.onDateChange('clockInTime', date)}
              type="text"
              dateFormat={'MM/DD/YYYY'}
              closeOnSelect={true}
              timeFormat={true}
              inputProps={{ placeholder: 'MM/DD/YYYY' }}
            />
          </Grid>
        </ListItem>
        <ListItem>
          <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
            Clock Out Time
          </Grid>
          <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
            <EditableDateInput
              className="emp-date-picker"
              valueToRender={
                timecard && timecard.timeCard && timecard.timeCard.clockOutTime
                  ? moment(new Date(timecard.timeCard.clockOutTime)).format('MM/DD/YYYY h:mm A')
                  : ''
              }
              editMode={true}
              value={
                timecard && timecard.timeCard && timecard.timeCard.clockOutTime
                  ? moment(new Date(timecard.timeCard.clockOutTime)).format('MM/DD/YYYY h:mm A')
                  : ''
              }
              onChange={(date) => this.onDateChange('clockOutTime', date)}
              type="text"
              dateFormat={'MM/DD/YYYY'}
              closeOnSelect={true}
              timeFormat={true}
              inputProps={{ placeholder: 'MM/DD/YYYY' }}
            />
          </Grid>
        </ListItem>
        <ListItem>
          <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
            <Checkbox
              checked={timecard && timecard.timeCard && timecard.timeCard.clockin}
              onChange={this.clockinChange}
            />
            <span className="labelField" item xs={6} sm={6} md={6} lg={6}>
              Clock in
            </span>
          </Grid>
        </ListItem>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/TimeCardEditForm.js